import React from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from ".././axios-interceptor";
import { base_url } from "./../utilities";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

const CurrencyExchangeView = (props) => {
  const [password, setPassword] = useState();
  const [currencyExchange, setCurrencyExchange] = useState();
  const [crcyExchange, setCrcyExchange] = useState();
  const [show, setShow] = useState(false);
  useEffect(() => {
    axios
      .post(base_url + "currency-exchange/get_latest_currency_exchange")
      .then((res) => {
        if(res.data.data[0] !=undefined){
          setCurrencyExchange(
            res.data.data[0].currency_exchange_value_with_dinar
          );
          setCrcyExchange(
            res.data.data[0].currency_exchange_value_with_dinar
          );
        }
        
      });
  }, []);

  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setCurrencyExchange(value);
  };
  const handleChangeInputPassword = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setPassword(value);
  };
  const handleClose = () => {
    setShow(false);
    props.onHide()
    setCurrencyExchange(crcyExchange)
  };

  const submitted = () => {
    if (
      currencyExchange == null ||
      currencyExchange == undefined ||
      currencyExchange == ""
    ) {
      toast.error("Please enter the exchange rate", {
        toastId: 2,
      });
    } else {
      props.onHide();
      setTimeout(() => {
        setShow(true);
      }, 800);
    }
  };

  const submittedPassword = () => {
    if (password == null || password == undefined || password == "") {
      toast.error("Please enter the password", {
        toastId: 2,
      });
    } else {
      let currency_data = {
        currency_exchange_value_with_dinar: currencyExchange,
        admin_user_name: Cookies.get("admin_user_name"),
        admin_user_id: Cookies.get("admin_user_id"),
        password: password,
      };
      axios
        .post(
          base_url + "currency-exchange/save_new_currency_exchange",
          currency_data
        )
        .then((res) => {
          if (res.data.message == "invalid password") {
            toast.error("invalid password", {
              toastId: 4,
            });
          } else if (res.data.status == 200) {
            toast.success("Success", {
              toastId: 4,
            });
            props.onHide();
            setTimeout(() => {
              window.location.reload();
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-100w"
        aria-labelledby="example-custom-modal-styling-title"
        size=""
        backdrop="static"
        keyboard={false}
        centered
        style={{ width: "19rem", margin: "auto", left: "40%", right: "40%" }}
      >
        <Modal.Header onHide={handleClose} closeButton className="modal_title">
          {" "}
        </Modal.Header>

        <Modal.Body
          className="px-4 py-2"
          style={{ height: "8rem", overflow: "auto" }}
        >
          <div className="h6">
            Currency Exchange Rate <span style={{ color: "red" }}> *</span>
          </div>
          <div className="row mt-4">
            <div className="col  mt-1 d-block">1 BHD =</div>
            <div className="col ">
              <InputGroup
                className="mb-3 bootStrp_form_conrtl_APNL"
                style={{ width: "180px" }}
              >
                <Form.Control
                  type="number"
                  className="rounded  shadow-ben"
                  id="currency"
                  name="currency"
                  role="presentation"
                  autoComplete="off"
                  value={currencyExchange}
                  onChange={handleChangeInput}
                />
                <InputGroup.Text className="percent_symbol">
                  USD
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex  ps-3 pe-3">
          <div>
            <button
              className="btn btn_background mx-2 px-3 py-2"
              onClick={handleClose}
            >
              Close
            </button>
            <button className="btn blue_btn mx-2 px-3 py-2" onClick={submitted}>
              Save
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        {...props}
        show={show}
        dialogClassName="modal-70w"
        aria-labelledby="example-custom-modal-styling-title"
        size=""
        backdrop="static"
        keyboard={false}
        centered
        style={{ width: "20rem", margin: "auto", left: "40%", right: "40%" }}
      >
        <Modal.Header onHide={handleClose} closeButton className="modal_title">
          {" "}
        </Modal.Header>

        <Modal.Body className=" py-2">
          <div className="row ps-2">
            <div className=" col-lg-10">
              <label htmlFor="password">
                Password<span style={{ color: "red" }}> *</span>
              </label>
              <br />
              <InputGroup className="mb-3 ">
                <Form.Control
                  type="password"
                  className="rounded "
                  id="password"
                  placeholder="Please enter your login password"
                  name="password"
                  role="presentation"
                  autoComplete="off"
                  onChange={handleChangeInputPassword}
                />
              </InputGroup>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex  ps-3 pe-3">
          <div>
            <button
              className="btn btn_background mx-2 px-3 py-2"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="btn blue_btn mx-2 px-3 py-2"
              onClick={submittedPassword}
            >
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CurrencyExchangeView;
